import React from 'react';
import { Input, InputProps } from '@chakra-ui/react';
import { POKER_COLORS } from '../../theme/designSystem';

const PokerInput: React.FC<InputProps> = (props) => {
  return (
    <Input
      bg={`${POKER_COLORS.darkTeal}33`}
      border={`2px solid ${POKER_COLORS.cyan}`}
      color={POKER_COLORS.cyan}
      _focus={{
        boxShadow: `0 0 12px ${POKER_COLORS.cyan}`,
        borderColor: POKER_COLORS.cyan,
      }}
      _placeholder={{
        color: 'gray.500',
      }}
      {...props}
    />
  );
};

export default PokerInput;